export const CONDITIONAL_FORMATTING_SETTING_NAME = 'mail_conditionalformatting';
